export const ALLORA_ORDER_FAX_NUMBER = '+1 (888) 317-2864';

export const resolveOrderFaxNumber = (...faxNumbers: Array<string | null | undefined>): string => {
	const providerFaxNumber = faxNumbers
		.map((faxNumber) => faxNumber?.trim())
		.find((faxNumber) => !!faxNumber);

	return providerFaxNumber ?? ALLORA_ORDER_FAX_NUMBER;
};
